import { useNavigate, useParams } from 'react-router-dom';

import { routes } from '@blockpulse3/data/shared';
import { CompanyCapitalType, useGetCompanyQuery } from '@blockpulse3/graphql/hooks';

import { NewFundraisingDocumentation } from '../NewFundraisingDocumentation';

type Props = unknown;

/**
 * NewPrivateFundraisingDocumentation.
 * Private fundraising version of the documentation step.
 *
 * @returns {JSX.Element}
 */
export function NewPrivateFundraisingDocumentation(): JSX.Element {
  const navigate = useNavigate();

  const { fundraisingId = '', companyId = '' } = useParams();
  const companyReq = useGetCompanyQuery({
    variables: { companyId },
    skip: !companyId,
  });
  const company = companyReq?.data?.company;

  const fundraisingRoutes = routes.workspace.fundraising.private;

  const handleFormSubmitCompleted = (): void => {
    if (!company) return;
    if (company.capitalType === CompanyCapitalType.FIXED) {
      navigate(fundraisingRoutes.iban.fmt(companyId, fundraisingId));
    } else {
      navigate(fundraisingRoutes.subscribers.fmt(companyId, fundraisingId));
    }
  };

  const handleFormCancel = (): void => {
    if (!company) return;
    navigate(fundraisingRoutes.parameters.fmt(companyId, fundraisingId));
  };

  return (
    <NewFundraisingDocumentation
      onCancel={handleFormCancel}
      onSubmitCompleted={handleFormSubmitCompleted}
    />
  );
}

export type NewPrivateFundraisingDocumentationProps = Props;
